import React from 'react';
import { useTranslation } from 'react-i18next';
import LoginForm from '../components/auth/LoginForm';

const LoginPage: React.FC = () => {
  const { t } = useTranslation('auth');
  
  return (
    <>
      <h2 className="text-center text-2xl font-semibold text-neutral-darkest mb-6">
        {t('login.page_title')}
      </h2>
      <LoginForm />
    </>
  );
};

export default LoginPage;